import { Button } from '@mui/material'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

const LanguagePicker = (): JSX.Element => {
  const { t, i18n } = useTranslation()
  const targetLanguage = t('common.targetLanguage')

  const changeLanguage = async () => {
    await i18n.changeLanguage(targetLanguage)
  }

  return <Button onClick={changeLanguage}>{targetLanguage}</Button>
}

export default LanguagePicker
